import OadpEntityButtonReadRule from './oadp-entity-button-read-rule';
export default OadpEntityButtonReadRule;
